import { render, staticRenderFns } from "./botNav.vue?vue&type=template&id=833c832e&scoped=true&"
import script from "./botNav.vue?vue&type=script&lang=js&"
export * from "./botNav.vue?vue&type=script&lang=js&"
import style0 from "./botNav.vue?vue&type=style&index=0&id=833c832e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c832e",
  null
  
)

export default component.exports